/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import { HAWAIIAN, FEET } from '../constants/units.js';

const getUnitType = unitType => {
  if (unitType == null) return null;
  if (unitType === HAWAIIAN) return FEET;
  return unitType; // no transformation needed
};

export default getUnitType;
//# sourceMappingURL=getUnitType.js.map
